/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import BetForm from './betForm'
import * as stringParser from '../../util/string.util'
import { calculateExpouser } from '../../util/expouser.util'
import Currency from './currency'
import Volume from './volume'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../../configs/const';
import { DemoBetDelay } from '../../configs/casinoShowList';
let oid = OPERATOR_ID.toLowerCase()
export default class WinnerOdds extends Component {
    constructor(props) {
        super(props);
        this.state = {
            runner_name: "",
            bid_at: "",
            bid_amount: 0,
            book: {},
            market: {},
            selectionId: "",
            expo: {},
            mktMsg: '',
            infoHide: true,
            width: document.documentElement.clientWidth
        };
        this.onChange = this.onChange.bind(this);
        this.changeBid = this.changeBid.bind(this);
    }
    selectBid(runner_name, bid_at, market_id, bid_for, team) {
        localStorage.setItem("betForm", JSON.stringify({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, selectionId: team.id.toString() }))
        this.setState({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, selectionId: team.id.toString() }, () => {
            this.props.betForm(market_id, bid_for, "clicked")
        })
    }
    componentWillUnmount() {
        if (!!this.props.socket) {
            this.props.socket.off("market_room")
        }
    }
    componentDidMount() {
        const socket = this.props.socket;
        let self = this
        if (this.props.market.bettingType === "BOOKMAKER" && !!this.props.teamSequence && this.props.teamSequence.length > 0) {
            this.props.market.runners = this.props.market.runners.sort(function (a, b) {
                return self.props.teamSequence.indexOf(a.name) - self.props.teamSequence.indexOf(b.name);
            });
            if (!!this.props.market.metadata && !!this.props.market.metadata.book) {
                this.props.market.metadata.book.runners = this.props.market.metadata.book.runners.sort(function (a, b) {
                    return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                });
            }
        }
        this.setState({ market: this.props.market, book: !!this.props.feedBooks[this.props.market.marketId] ? this.props.feedBooks[this.props.market.marketId] : !!this.props.market.metadata && !!this.props.market.metadata.book ? this.props.market.metadata.book : {} }, () => {
            if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                this.props.betForm("", "")
            }
        })
        if (!this.props.market.metadata || !this.props.market.metadata.book || this.props.market.metadata.book.status === "CLOSED" || this.props.market.metadata.book.status === "INACTIVE") {
            return false
        }
        if (localStorage.getItem("betExpo")) {
            this.setState({ expo: JSON.parse(localStorage.getItem("betExpo")) })
        }
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if (!!accData && Object.keys(accData).length > 0) {
            if (this.props.subscribedMarkets.indexOf(this.props.market.marketId) === -1) {
                if (this.props.subscriptions.market_room.indexOf(this.props.market.marketId) === -1) {
                    socket.emit('market_room', this.props.market.marketId)
                    this.props.subscribe('market_room', this.props.market.marketId)
                    this.props.updateSubscribedMarkets(this.props.market.marketId)
                }
            }
            let stream = ""
            socket.on("message_room", data => {
                let objData = JSON.parse(data)
                if (!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId === this.props.market.marketId) {
                    this.setState({ mktMsg: objData.payload.message })
                    if(this.props.updateMktMsg){
                      this.props.updateMktMsg(objData.payload)
                    }
                }
            });
            socket.on("market_room", data => {
                // let objData = JSON.parse(data)
                // if(!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId ===  this.props.market.marketId){
                // this.setState({mktMsg:objData.payload.message})
                // }else 
                if (stream !== data) {
                    stream = data
                    let newBook = null
                    try {
                        newBook = stringParser.deSrlz(data)
                    } catch {
                        let baseData = {
                            marketId: this.props.market.marketId,
                            status: "OPEN",
                            runners: []
                        }
                        this.state.market.runners.forEach((rnr) => {
                            let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                            baseData.runners.push(data)
                        })
                        newBook = baseData
                    }
                    if (this.props.market.bettingType === "BOOKMAKER") {
                        if (!!newBook.runners) {
                            newBook.runners = newBook.runners.sort(function (a, b) {
                                return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                            });
                        }
                    }
                    if (this.props.market.marketId === newBook.marketId) {
                        this.props.updateBook(this.props.market.marketId, newBook)
                        let curBook = this.state.book
                        if (!curBook || !curBook.runners) {
                            this.setState({ book: newBook })
                            return false
                        }
                        curBook.runners.forEach((rn, i) => {
                            let nrn = newBook.runners[i]
                            if (!nrn) {
                                nrn = {}
                                nrn.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                                nrn.lay = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            }
                            if (!nrn.back || nrn.back.length === 0) {
                                newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            }
                            rn.back.forEach((bk, j) => {
                                if (!!nrn.back[j]) {
                                    if (bk.price !== nrn.back[j].price) {
                                        nrn.back[j].has_blink = true
                                    }
                                    else {
                                        nrn.back[j].has_blink = false
                                    }
                                }
                            })
                            if (!nrn.lay || nrn.lay.length === 0) {
                                newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            }
                            if (!!rn.lay && rn.lay.length > 0) {
                                rn.lay.forEach((ly, k) => {
                                    if (!!nrn.lay[k]) {
                                        if (ly.price !== nrn.lay[k].price) {
                                            nrn.lay[k].has_blink = true
                                        }
                                        else {
                                            nrn.lay[k].has_blink = false
                                        }
                                    }
                                })
                            }
                            newBook.runners[i] = nrn
                        });
                        this.setState({ book: newBook }, () => {
                            if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                                this.props.betForm("", "")
                            }
                            setTimeout(() => {
                                curBook.runners.forEach((rn, i) => {
                                    let nrn = newBook.runners[i]
                                    rn.back.forEach((bk, j) => {
                                        if (!!nrn.back[j]) {
                                            nrn.back[j].has_blink = false
                                        }
                                    })
                                    rn.lay.forEach((ly, k) => {
                                        if (!!nrn.lay[k]) { nrn.lay[k].has_blink = false }
                                    })
                                    newBook.runners[i] = nrn
                                });
                                this.setState({ book: newBook })
                            }, 500)
                        })
                    }
                }
            });
            setInterval(() => {
                socket.on("market_room", data => {
                    if (stream !== data) {
                        stream = data
                        let newBook = null
                        try {
                            newBook = stringParser.deSrlz(data)
                        } catch {
                            let baseData = {
                                marketId: this.props.market.marketId,
                                status: "OPEN",
                                runners: []
                            }
                            this.state.market.runners.forEach((rnr) => {
                                let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                                baseData.runners.push(data)
                            })
                            newBook = baseData
                        }
                        if (this.props.market.bettingType === "BOOKMAKER") {
                            if (!!newBook.runners) {
                                newBook.runners = newBook.runners.sort(function (a, b) {
                                    return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                                });
                            }
                        }
                        if (this.props.market.marketId === newBook.marketId) {
                            this.props.updateBook(this.props.market.marketId, newBook)
                            let curBook = this.state.book
                            if (!curBook || !curBook.runners) {
                                this.setState({ book: newBook })
                                return false
                            }
                            curBook.runners.forEach((rn, i) => {
                                let nrn = newBook.runners[i]
                                if (!nrn) {
                                    nrn = {}
                                    nrn.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                                    nrn.lay = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                                }
                                if (!nrn.back || nrn.back.length === 0) {
                                    newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                                }
                                rn.back.forEach((bk, j) => {
                                    if (!!nrn.back[j]) {
                                        if (bk.price !== nrn.back[j].price) {
                                            nrn.back[j].has_blink = true
                                        }
                                        else {
                                            nrn.back[j].has_blink = false
                                        }
                                    }
                                })
                                if (!nrn.lay || nrn.lay.length === 0) {
                                    newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                                }
                                if (!!rn.lay && rn.lay.length > 0) {
                                    rn.lay.forEach((ly, k) => {
                                        if (!!nrn.lay[k]) {
                                            if (ly.price !== nrn.lay[k].price) {
                                                nrn.lay[k].has_blink = true
                                            }
                                            else {
                                                nrn.lay[k].has_blink = false
                                            }
                                        }
                                    })
                                }
                                newBook.runners[i] = nrn
                            });
                            this.setState({ book: newBook }, () => {
                                if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                                    this.props.betForm("", "")
                                }
                                setTimeout(() => {
                                    curBook.runners.forEach((rn, i) => {
                                        let nrn = newBook.runners[i]
                                        rn.back.forEach((bk, j) => {
                                            if (!!nrn.back[j]) {
                                                nrn.back[j].has_blink = false
                                            }
                                        })
                                        rn.lay.forEach((ly, k) => {
                                            if (!!nrn.lay[k]) { nrn.lay[k].has_blink = false }
                                        })
                                        newBook.runners[i] = nrn
                                    });
                                    this.setState({ book: newBook })
                                }, 500)
                            })
                        }
                    }
                });
            }, 15000);
            socket.on('disconnect', () => {
                socket.emit('market_room', this.props.market.marketId)
            })
        }
    }
    changeBid(val) {
        this.setState({ bid_amount: val })
    }
    updateExpo(exp) {
        this.setState({ expo: {} }, () => {
            this.setState({ expo: exp })
        })
        localStorage.setItem("betExpo", JSON.stringify(exp))
    }
    onChange(e) {
        this.changeBid(e.target.value)
    }
    thexInputClick(val) {
        let cur_amount = this.state.bid_amount.toString()
        let new_amount = ""
        if (val !== "back") {
            new_amount = cur_amount + val.toString()
        } else {
            new_amount = cur_amount.substring(0, cur_amount.length - 1);
        }
        this.changeBid(new_amount)
    }
    userPropertyUpdate() {
        let market = this.props.market
        let userMktCondition = localStorage.getItem("accountData")
        userMktCondition = JSON.parse(userMktCondition)
        market.minBet = !!userMktCondition && userMktCondition.minBet ? Math.max(market.marketCondition.minBet, userMktCondition.minBet) : market.marketCondition.minBet
        if (market.marketCondition.maxBet === 0) {
            market.maxBet = userMktCondition?.maxBet
        } else if (!userMktCondition || userMktCondition?.maxBet === 0) {
            market.maxBet = market.marketCondition.maxBet
        } else {
            market.maxBet = market.marketCondition.maxBet
        }
        market.betDelay = !!userMktCondition ? Math.max(market.marketCondition.betDelay, userMktCondition.betDelay) : market.marketCondition.betDelay
        return market
    }
    addBetFn(dt, mkt){
        dt.marketId = mkt.marketId; 
        dt.selectionId = this.state.selectionId; 

        const prfdt = JSON.parse(localStorage.getItem('profData'));
        if(prfdt?.role === 'DemoClient'){
            this.props.togglebetLoader()    
                setTimeout(() => {    
                    let price = dt.price
                    this.state.book.runners.forEach((itm)=>{
                        if(itm.selectionId === dt.selectionId){
                            price = itm[dt.bet_for][0].price;
                        }
                    })
                    dt.price = price;
                    this.props.addBet(dt)
                }, DemoBetDelay);
        } else {
            this.props.addBet(dt)
        }
    }
    calculateLineExpo(market, expo){
        let mktLineExpo = {}
        if(!!market.runners && market.runners.length > 0){
            market.runners.forEach((runner, i) => {
                mktLineExpo[runner.name] = {}
                mktLineExpo[runner.name].expo = parseFloat(expo[runner.id.toString()]).toFixed(2)
            })
        }
        return mktLineExpo
    }
    render() {
        const accData = JSON.parse(localStorage.getItem("accountData"));
        let market = this.userPropertyUpdate();
        let book = this.state.book
        let mktBets = []
        if (this.props.curBets) {
            mktBets = this.props.curBets.filter((bet, i) => {
                return bet.marketId === this.props.market.marketId
            })
        }
        let marketExpo = calculateExpouser(market, market.runners[0].marketId, "back", 0, 0, mktBets)
        let mktLineExpo = this.calculateLineExpo(market, marketExpo)
        let overallExpo = Math.min.apply(null, Object.keys(marketExpo).map((elem) => { return marketExpo[elem] }))
        let multiplayFector = market.marketCondition.volume
        let currencyConversion = (!!accData && Object.keys(accData).length > 0) ? JSON.parse(localStorage.getItem('profData')).currencyConversion : 1;
        let isLottry = !!market.runners && market.runners.length === 10 && market.runners[0].name === "0" && market.runners[9].name === "9";
        return (
            <>

                {!this.state.infoHide && (
                    <div
                        className="mobile-show"
                        style={{
                            background: "#000",
                            padding: "5px",
                            borderRadius: "5px",
                            position: "absolute",
                            width: "100%",
                            zIndex: "1",
                            marginTop: "0px",
                            color: "#fff"
                        }}
                        onClick={() => {
                            this.setState({ infoHide: true });
                        }}
                    >
                        <span className="d-block ">
                            {" "}
                            {!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}
                            <span className='pull-right'>
                                <i className="fa fa-close" aria-hidden="true"></i>
                            </span>
                        </span>
                    </div>
                )}
                {/* <div className="sub_path center-box crname crname-winneroffd mt-2_5">
                    <p>
                        {(!!accData && Object.keys(accData).length > 0) && <a id="multiMarketPin" onClick={(e) => { e.stopPropagation(); this.props.toggleMultiMarket(market.marketId); }} className={this.props.pinnedEvents.indexOf(market.marketId) > -1 ? "multimarket-pin select" : "multimarket-pin"} style={{ "cursor": "pointer" }} title="Remove from Multi Markets"><i className="fa fa-thumb-tack" aria-hidden="true"></i></a>}
                        <span className='mr-1' onClick={() => {
                            if(this.state.width < 768){
                                this.setState({ infoHide: false });
                            }
                            }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span> */}
                <div className="sub_path center-box crname crname-winneroffd mt-2_5">
                    <p>
                        {(!!accData && Object.keys(accData).length > 0) && <a id="multiMarketPin" onClick={(e) => { e.stopPropagation(); this.props.toggleMultiMarket(market.marketId); }} className={this.props.pinnedEvents.indexOf(market.marketId) > -1 ? "multimarket-pin select" : "multimarket-pin"} style={{ "cursor": "pointer" }} title="Remove from Multi Markets"><i className="fa fa-thumb-tack" aria-hidden="true"></i></a>}
                        {/* <span className='mr-1' onClick={() => {
                            if(this.state.width < 768){
                                this.setState({ infoHide: false });
                            }
                            }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span> */}

                        {/*  */}

                        {this.state.width > 991 ? (
                            <>
                                <span className='mr-1' onClick={() => {
                                    if (this.state.width < 768) {
                                        this.setState({ infoHide: false });
                                    }
                                }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            </>
                        ) : this.state.width >= 768 &&
                            market.marketName.length < 52 ? (
                            <>
                                <span className='mr-1' onClick={() => {
                                    if (this.state.width < 768) {
                                        this.setState({ infoHide: false });
                                    }
                                }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            </>
                        ) : this.state.width >= 575 &&
                            market.marketName.length < 45 ? (
                            <>
                                <span className='mr-1' onClick={() => {
                                    if (this.state.width < 768) {
                                        this.setState({ infoHide: false });
                                    }
                                }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            </>
                        ) : this.state.width >= 500 &&
                            market.marketName.length < 37 ? (
                            <>
                                <span className='mr-1' onClick={() => {
                                    if (this.state.width < 768) {
                                        this.setState({ infoHide: false });
                                    }
                                }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            </>
                        ) : this.state.width >= 469 &&
                            market.marketName.length < 37 ? (
                            <>
                                <span className='mr-1' onClick={() => {
                                    if (this.state.width < 768) {
                                        this.setState({ infoHide: false });
                                    }
                                }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            </>
                        ) : this.state.width >= 414 &&
                            market.marketName.length < 37 ? (
                            <>
                                <span className='mr-1' onClick={() => {
                                    if (this.state.width < 768) {
                                        this.setState({ infoHide: false });
                                    }
                                }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            </>
                        ) : this.state.width >= 390 &&
                            market.marketName.length < 25 ? (
                            <>
                                <span className='mr-1' onClick={() => {
                                    if (this.state.width < 768) {
                                        this.setState({ infoHide: false });
                                    }
                                }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            </>
                        ) : this.state.width >= 375 &&
                            market.marketName.length < 35 ? (
                            <>
                                <span className='mr-1' onClick={() => {
                                    if (this.state.width < 768) {
                                        this.setState({ infoHide: false });
                                    }
                                }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            </>
                        ) : this.state.width >= 374 &&
                            market.marketName.length < 35 ? (
                            <>
                                <span className='mr-1' onClick={() => {
                                    if (this.state.width < 768) {
                                        this.setState({ infoHide: false });
                                    }
                                }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            </>
                        ) : this.state.width >= 320 &&
                            market.marketName.length < 20 ? (
                            <>
                                <span className='mr-1' onClick={() => {
                                    if (this.state.width < 768) {
                                        this.setState({ infoHide: false });
                                    }
                                }}>{!!market.marketName ? market.marketName : market.marketType.replace("_", " ")}</span>
                            </>
                        ) : (
                            // eslint-disable-next-line jsx-a11y/no-distracting-elements
                            <marquee scrollamount="2" behavior="scroll" className="marquee-w-43_8">
                                <span className="marketnamemobile  marquee-winnerodds" title={market.marketName} style={{ fontWeight: "bold", cursor: "pointer", }}  > {!!market.marketName ? market.marketName : market.marketType.replace("_", " ")} </span> </marquee>
                        )}

                        {/*  */}
                        {this.props.isRebateBonus && <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/rebatebonusicon.gif"} className="rebatebonusicon rebatebonusicon-mobile"></img>}

                        <span className="f-right min-max marquee-winnerodds-min-max">
                            {this.props.isRebateBonus && <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/rebatebonusicon.gif"} className="rebatebonusicon"></img>}Min: {(market.minBet / currencyConversion).toFixed(2)} | Max: {(market.maxBet / currencyConversion).toFixed(2)}
                            <span className={"f-right pl-3 "}>{this.props.hideMkt.indexOf(market.marketId) > -1 ? <i className="fa fa-plus" aria-hidden="true" onClick={(e) => { e.stopPropagation(); this.props.toggleOpenMkt(market.marketId) }}></i> : <i className="fa fa-minus" aria-hidden="true" onClick={(e) => { e.stopPropagation(); this.props.toggleOpenMkt(market.marketId) }}></i>}</span>
                        </span>
                    </p>
                </div>
                <div className="game-wrap col3 mb-1">
                            {this.props.hideMkt.indexOf(market.marketId) === -1 && isLottry &&
                                    <>
                                    <div className='lotterymainuibox'>
                                        <div className='lott-flex w-30-lottery ml-1'>
                                            {mktBets.length > 0 && <button className='btn-cashout mr-2' onClick={()=>{this.props.showExpo(mktLineExpo, market.marketName)}}>Book</button> }
                                            {mktBets.length > 0 && <Currency key={"mktexpo"} classPropName={"match-odds font-weight-bold"} amount={overallExpo} showColor={true} />}
                                        </div>
                                        <div className='w-70-lottery'>
                                            <div className='new-lotteryui '>                                            
                                                <div className='new-lotteryui-box grid-container-lottery '>
                                                {!!market.runners && market.runners.map((runner, i) => {
                                                    let runner_bk = !!this.state.book && this.state.book !== {} && !!this.state.book.runners && this.state.book.runners.length > 0 ? this.state.book.runners.filter((r) => { return r.selectionId.toString() === runner.id.toString() })[0] : null
                                                    runner.name = market.runners[i].name
                                                    let is_active = book.status === "OPEN" && runner_bk.status === "ACTIVE" ? true : false /// TEMP BYPASS
                                                    return (
                                                        <>
                                                            {!!runner_bk && runner_bk.status !== "REMOVED" && <a onClick={() => { !!runner_bk.back && !!runner_bk.back[0] && !!runner_bk.back[0].price && runner_bk.back[0].price > 0 && !market.betLock && this.selectBid(runner.name, runner_bk.back[0].price, market.marketId, "back", runner) }} className={`btn-back border-bottom1 w-100 text-center d-block font-weight-bold br-radius3 grid-item-lottery ${this.state.runner_name === runner.name && this.props.selected_market === market.marketId  ? 'select' : ''} ${is_active? (book.sportingEvent === true ? 'ballrunning-winnerodds-lottery' : '') : 'suspended-winnerodds-lottery'}`} side="Back">
                                                                <div>{runner.name}</div>
                                                            </a>}
                                                        </>
                                                        )}
                                                    )}                                       
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                                <table className="table w-100 game-list-col eventdetails bets mb-0">
                                                    <tbody>
                                                        {!!this.props.msgMarket &&
                                                            <tr className="">
                                                                <td colSpan="2"><span className="fancymassage float-right bmmassage"><i className="fa fa-envelope mr-1"></i> {this.props.msgMarket}</span></td>
                                                            </tr>
                                                        }
                                                        {
                                                            this.props.selected_market === market.marketId &&
                                                            <BetForm loadingBet={this.props.loadingBet} notify={(msg, type) => { this.props.notify(msg, type) }} eventMarket={market} selcted_bet_option={this.props.selcted_bet_option} curBets={this.props.curBets} updateExpo={(expo) => { this.updateExpo(expo) }} selectionId={this.state.selectionId} runner_name={this.state.runner_name} bid_at={this.state.bid_at} betForm={this.props.betForm} addBet={(data) => { this.addBetFn(data, market) }} />
                                                        }
                                                    </tbody>
                                                </table>
                                    </>
                            }
                    {this.props.hideMkt.indexOf(market.marketId) === -1 && !isLottry && <div className='container winnerodds-market'>
                        <div className='row '>
                            {!!market.runners && market.runners.map((runner, i) => {
                                let runner_bk = !!this.state.book && this.state.book !== {} && !!this.state.book.runners && this.state.book.runners.length > 0 ? this.state.book.runners.filter((r) => { return r.selectionId.toString() === runner.id.toString() })[0] : null
                                runner.name = market.runners[i].name
                                let is_active = book.status === "OPEN" && runner_bk.status === "ACTIVE" ? true : false
                                return (
                                    <>
                                        {!!runner_bk && runner_bk.status !== "REMOVED" && <div className={market.runners.length <= 2 ? 'col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6' : 'col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4'}>
                                            <div className='d-inline-flex w-100 lottery-p-2 odds'>
                                                <div className='d-inline-block lottery-w75 lottery-inplay v-align-top'>{runner.name}
                                                    {mktBets.length > 0 && <Currency key={"mktexpo"} classPropName={"match-odds font-weight-bold"} amount={marketExpo[runner.id]} showColor={true} />}
                                                    <span className={"float-right"} style={{ marginBottom: '15px', marginRight: '1rem', position: 'absolute', top: '18px', right: '35%' }}>
                                                        {!!this.state.expo && this.state.expo[runner.id] && this.props.selected_market === this.props.market.marketId ? <Currency key={"expo"} classPropName={"match-odds font-weight-bold"} amount={this.state.expo[runner.id]} showColor={true} /> : ""}
                                                    </span>
                                                </div>
                                                <div className={book.status === "OPEN" && runner_bk.status === "ACTIVE" ? book.sportingEvent === true ? 'd-inline-block lottery-w25 lottery-inplay btn-back ballrunning-winnerodds' : 'd-inline-block lottery-w25 lottery-inplay btn-back' : 'd-inline-block lottery-w25 lottery-inplay btn-back suspended-winnerodds'}>
                                                    {!!runner_bk.back && <div onClick={() => { !!runner_bk.back[0] && !!runner_bk.back[0].price && runner_bk.back[0].price > 0 && !market.betLock && this.selectBid(runner.name, runner_bk.back[0].price, market.marketId, "back", runner) }}>
                                                        <a className="btn-back border-bottom1 w-100 text-center d-block font-weight-bold " side="Back" >
                                                            <div>{!!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 && is_active ? (runner_bk.back[0].price.indexOf('.') > -1 ? runner_bk.back[0].price.substring(0, (runner_bk.back[0].price.indexOf('.') + 3)) : runner_bk.back[0].price) : ""}</div>
                                                        </a>
                                                    </div>}
                                                </div>
                                            </div>
                                        </div>}
                                    </>
                                )
                            })}
                            <table className="table w-100 game-list-col eventdetails bets mb-0">
                                <tbody>
                                    {!!this.props.msgMarket &&
                                        <tr className="">
                                            <td colSpan="2"><span className="fancymassage float-right bmmassage"><i className="fa fa-envelope mr-1"></i> {this.props.msgMarket}</span></td>
                                        </tr>
                                    }
                                    {
                                        this.props.selected_market === market.marketId &&
                                        <BetForm loadingBet={this.props.loadingBet} notify={(msg, type) => { this.props.notify(msg, type) }} eventMarket={market} selcted_bet_option={this.props.selcted_bet_option} curBets={this.props.curBets} updateExpo={(expo) => { this.updateExpo(expo) }} selectionId={this.state.selectionId} runner_name={this.state.runner_name} bid_at={this.state.bid_at} betForm={this.props.betForm} addBet={(data) => { this.addBetFn(data, market) }} />
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>}
                </div>
                
            </>
        )
    }
}

